import React from 'react'
import './CodingProfiles.css'
import Leetcode from '../../assets/leetcode-logo.png';
import Codeforces from '../../assets/codeforces-logo.png';
import Codechef from '../../assets/codechef-logo.png';
import Gfg from '../../assets/gfg-logo.png';

function CodingProfiles() {
  return (
    <>
      <div className='container'>
        <div className="header-text-h1">
          <h1 className='header-text'>Coding Profiles</h1>
        </div>
        <div className="row mx-lg-5 align-items-center" style={{ marginTop: '60px' }}>
          <div class="container profile-page">
            <div class="row col-12">
              <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="card profile-header profile-shadow">
                  <div class="body">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-12">
                        <div class="profile-image float-md-right"> <img src={Leetcode} alt="" /> </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-12">
                        <h4 class="m-t-0 m-b-0 justify-content-start">leetcode/dharmeshkporiya</h4>
                        <span class="job_post"><strong>Contest rating : </strong>1696 (max 1733)</span>
                        <p>Solved 850+ problems on various data structure.</p>
                        <div>
                          <a href={'https://leetcode.com/dharmeshkporiya/'} target='_blank' rel='noReferrer' class="btn btn-primary btn-round btn-simple w-100">View Profile</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="card profile-header profile-shadow">
                  <div class="body">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-12">
                        <div class="profile-image float-md-right"> <img src={Codeforces} alt="" /> </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-12">
                        <h4 class="m-t-0 m-b-0 justify-content-start" style={{ marginLeft: '-10px' }}>codeforces/dharmesh.poriya07</h4>
                        <span class="job_post"><strong>Contest rating : </strong>976 (max newbie - 976)</span>
                        <p>Solved 30+ problems on contest.</p>
                        <div>
                          <a href={'https://codeforces.com/profile/dharmesh.poriya07'} target='_blank' rel='noReferrer' class="btn btn-primary btn-round btn-simple w-100">View Profile</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="card profile-header profile-shadow">
                  <div class="body">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-12">
                        <div class="profile-image float-md-right"> <img src={Codechef} alt="" /> </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-12">
                        <h4 class="m-t-0 m-b-0 justify-content-start">codechef/d_poriya_07</h4>
                        <span class="job_post"><strong>Contest rating : </strong>1503 (max 1559)</span>
                        <p>Solved 200+ problems on contest.</p>
                        <div>
                          <a href={'https://www.codechef.com/users/d_poriya_07'} target='_blank' rel='noReferrer' class="btn btn-primary btn-round btn-simple w-100">View Profile</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-xl-6 col-lg-7 col-md-12 col-sm-12 col-12">
                <div class="card profile-header profile-shadow">
                  <div class="body">
                    <div class="row">
                      <div class="col-lg-4 col-md-4 col-12">
                        <div class="profile-image float-md-right"> <img src={Gfg} alt="" /> </div>
                      </div>
                      <div class="col-lg-8 col-md-8 col-12">
                        <h4 class="m-t-0 m-b-0 justify-content-start">gfg/dharmeshkporiya</h4>
                        <span class="job_post"><strong>Institute rank : </strong>3</span>
                        <p>Solved 400+ problems on various data structure.</p>
                        <div>
                          <a href={'https://auth.geeksforgeeks.org/user/dharmeshkporiya/'} target='_blank' rel='noReferrer' class="btn btn-primary btn-round btn-simple w-100">View Profile</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default CodingProfiles